import Form from "components/Form";
import ResponsiveCard from "components/ResponsiveCard";
import Section from "components/Section";
import useProfissoes from "hooks/useProfissoes";
import useRendas from "hooks/useRendas";
import { required } from "utils/form/validations";

const DadosProfissionais = ({ validationRef, initialValue }) => {
  const { profissoes, loading: loadingProfissoes } = useProfissoes();
  const { faixasRenda, loading: loadingRenda } = useRendas();

  return (
    <section>
      <Section>
        <ResponsiveCard maxContent title="Dados profissionais">
          <Form.Section validationRef={validationRef} scheme={initialValue}>
            <Form.InputSelect
              name="profissao"
              label="Profissão"
              options={profissoes}
              placeholder="Selecione uma opção"
              validationRules={[required]}
              loading={loadingProfissoes}
              minSearch={2}
              half
            />
            <Form.InputSelect
              label="Renda mensal"
              name="renda"
              options={faixasRenda}
              placeholder="Selecione uma faixa de renda"
              validationRules={[required]}
              loading={loadingRenda}
              half
              selectOnly
            />
          </Form.Section>
        </ResponsiveCard>
      </Section>
    </section>
  );
};

export default DadosProfissionais;
